import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './FloatingLedgerLock.module.css';

// Pages where the floating tab should not appear
const HIDDEN_ON = ['/ledgerlock', '/admin', '/login'];

const FloatingLedgerLock = () => {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem('ledgerlock-float-dismissed') === '1';
    } catch (e) {
      return false;
    }
  });

  if (dismissed || HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDismissed(true);
    try {
      sessionStorage.setItem('ledgerlock-float-dismissed', '1');
    } catch (err) {
      /* storage unavailable — dismiss for this view only */
    }
  };

  return (
    <div className={styles.wrap}>
      <Link to="/ledgerlock" className={styles.tab} aria-label="Discover LedgerLock, the offline accounting app">
        <span className={styles.icon} aria-hidden="true">🔐</span>
        <span className={styles.text}>
          <strong>LedgerLock</strong>
          <small>Offline accounting app · Try free</small>
        </span>
        <span className={styles.arrow} aria-hidden="true">→</span>
      </Link>
      <button type="button" className={styles.close} onClick={dismiss} aria-label="Dismiss LedgerLock banner">×</button>
    </div>
  );
};

export default FloatingLedgerLock;
